export const userStore = {
  namespaced: true,
  state: {
    user: {},
    userRights: [],
    userContract: {},
  },
  getters: {
    courseRecommendations(state) {
      return state.user?.courseRecommendations || []
    },
    userName(state) {
      return state.user ? state.user.userName : ""
    },
    userWeight(state) {
      return state.user ? state.user.gewicht : ""
    },
    userContract(state) {
      return state.userContract || null
    },
    activeContractDetails(state) {
      const contractData = state.userContract
      if (!contractData || !contractData.ContractID) {
        console.log("No contract data available or ContractID is missing.")
        return null
      }

      // Helper zum Formatieren
      const formatDate = (dateString) => {
        if (!dateString || typeof dateString !== "string") return null
        const d = new Date(dateString)
        const day = String(d.getDate()).padStart(2, "0")
        const month = String(d.getMonth() + 1).padStart(2, "0")
        const year = d.getFullYear()
        return `${day}.${month}.${year}`
      }

      // =================================================================
      // HAUPTVERTRAG-LOGIK (Repliziert deine computed-Property)
      // =================================================================

      let mainContractInfo = null

      if (contractData.ContractTermTimes && Array.isArray(contractData.ContractTermTimes.ContractTermTime)) {
        const timeSpans = contractData.ContractTermTimes.ContractTermTime
        const today = new Date()
        today.setHours(23, 59, 59, 999)

        // 1. Finde den Start-Tag des aktiven Vertrags-Zeitraums (exakt wie in deiner Logik)
        const activeContractStartDate = [...timeSpans].reverse().find((ts) => {
          // Erstelle ein Datum aus dem Vertrag und setze es ebenfalls auf Mitternacht
          const contractStart = new Date(ts.TimeSpan.Start)
          contractStart.setHours(0, 0, 0, 0)

          return ts.Type === "DEFAULT" && contractStart <= today
        })?.TimeSpan.Start

        if (activeContractStartDate) {
          // 2. Finde den zugehörigen Basis-Block
          const activeBaseSpan = timeSpans.find((ts) => ts.Type === "DEFAULT" && ts.TimeSpan.Start === activeContractStartDate)

          // 3. Extrahiere alle Boni und Pausen (Timestops)
          // WICHTIG: Deine Logik für "timeStopBonus" war sehr spezifisch (DEFAULT-Spans, die Pausen ausgleichen).
          // Der Einfachheit und Robustheit halber identifizieren wir hier explizite Typen.
          const bonusExtensions = timeSpans
            .filter((ts) => ts.Type === "BONUSPERIOD")
            .map((ts) => ({
              startDate: formatDate(ts.TimeSpan.Start),
              endDate: formatDate(ts.TimeSpan.End),
            }))

          const pauses = timeSpans
            .filter((ts) => ts.Type === "IDLEPERIOD")
            .map((ts) => ({
              startDate: formatDate(ts.TimeSpan.Start),
              endDate: formatDate(ts.TimeSpan.End),
            }))

          // 4. Berechne das finale Enddatum (exakt wie in deinem Template)
          let finalEndDate = activeBaseSpan.TimeSpan.End
          if (bonusExtensions.length > 0) {
            // Finde das späteste Enddatum aller Bonus-Verlängerungen
            const lastBonusEnd = bonusExtensions.reduce((latest, current) =>
              new Date(current.endDate.split(".").reverse().join("-")) > new Date(latest.endDate.split(".").reverse().join("-")) ? current : latest
            ).endDate
            if (new Date(lastBonusEnd.split(".").reverse().join("-")) > new Date(finalEndDate)) {
              finalEndDate = lastBonusEnd.split(".").reverse().join("-")
            }
          }

          // Hier könnte man die Logik für "timeStopBonus" einfügen, falls nötig.
          // Fürs Erste fokussieren wir auf explizite BONI.

          mainContractInfo = {
            title: contractData.MemberCategoryName,
            startDate: formatDate(activeBaseSpan.TimeSpan.Start),
            endDate: formatDate(activeBaseSpan.TimeSpan.End),
            finalEndDate: formatDate(finalEndDate),
            extensions: {
              bonus: bonusExtensions,
              // Placeholder für deine timeStopBonus Logik, falls diese noch benötigt wird
              compensatory: [],
            },
            pauses: pauses,
          }
        }
      }

      // =================================================================
      // ZUSATZPAKETE (SubContracts)
      // =================================================================

      let addons = []
      let activeAddons = []
      if (contractData.SubContracts && Array.isArray(contractData.SubContracts.SubContract)) {
        addons = contractData.SubContracts.SubContract.map((sub) => {
          // ... (Status-Logik von vorher bleibt gleich)
          const today = new Date()
          today.setHours(23, 59, 59, 999)
          const startDate = new Date(sub.ContractStartDate)
          startDate.setHours(0, 0, 0, 0)
          const endDate = new Date(sub.ContractEndDate)
          endDate.setHours(23, 59, 59, 999)
          let status = "ACTIVE"
          if (sub.ContractState === 5 || endDate < today) status = "EXPIRED"
          else if (startDate > today) status = "FUTURE"

          return {
            type: "ADDON",
            title: sub.MemberCategoryName,
            startDate: formatDate(sub.ContractStartDate),
            endDate: formatDate(sub.ContractEndDate),
            status: status,
          }
        })

        activeAddons = addons.filter((addon) => addon.status === "ACTIVE")
      }

      // =================================================================
      // FINALES OBJEKT
      // =================================================================

      if (!mainContractInfo) return null // Ohne Hauptvertrag macht es keinen Sinn

      return {
        ...mainContractInfo,
        addons: activeAddons,
        allAddons: addons,
        activeAddonsTitles: activeAddons.filter((addon) => addon.status === "ACTIVE").map((addon) => addon.title),
      }
    },
  },
  mutations: {
    setUser(state, data) {
      state.user = data
    },
    setUserRights(state, data) {
      state.userRights = data
    },
    setUserContract(state, data) {
      state.userContract = data
    },
  },
  actions: {
    setUser({ commit }, data) {
      console.log("setting user")
      commit("setUser", JSON.parse(JSON.stringify(data)))
    },
    setUserRights({ commit }, data) {
      console.log("setting user rights")
      commit("setUserRights", JSON.parse(JSON.stringify(data)))
    },
    setUserContract({ commit }, data) {
      console.log("setting user contract")
      commit("setUserContract", JSON.parse(JSON.stringify(data)))
    },
  },
}
